var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { attrs: { role: "navigation", "aria-label": "dropdown navigation" } },
    [
      _c(
        "RouterLink",
        {
          staticClass: "navbar-item is-flex has-text-white",
          attrs: { to: { name: "Home" } }
        },
        [
          _c("BIcon", { attrs: { icon: "poll-box" } }),
          _c("span", [_vm._v("Facturación")])
        ],
        1
      ),
      _c(
        "RouterLink",
        {
          staticClass: "navbar-item is-flex has-text-white",
          attrs: { to: { name: "UsersList" } }
        },
        [
          _c("BIcon", { attrs: { icon: "account-group" } }),
          _c("span", [_vm._v("Usuarios")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }